module.exports = __webpack_public_path__ + "static/media/incident_category-cyber.edc53f6f.svg";